import React from 'react';
import styles from './DeletePatient.module.scss';

import { IoTrashOutline } from 'react-icons/io5';
import api from '../../../helpers/api';
import { $t } from '../../../helpers/translator';
import Modal from '../../miscellaneous/Modal/Modal';


class ClinicDeletePatient extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    presentApprovalModal() {
        this.setState({ showModal: true }, () => {
            // console.log(this.state)
        });
    }

    closeModals() {
        this.setState({ showModal: false });
    }

    async deletePatient() {
        try {
            // let res = await api.deletePatient(Number(this.props.id));
            let res = await api.delete(`patient/${this.props.id}`);
            if (res && res.data && res.data.success) {
                this.props.onSuccess({ success: true });
                this.setState({ showModal: false });
            }
        } catch (e) {
            console.error('err deleting:', e);
        }
    }

    renderContent() {
        return (
            <div className={`${styles['delete-container']}` }>
                <div className={`${styles['first-row']}` }>
                    {$t('global.patients.deletePatient')}
                </div>
                <div className={`${styles['second-row']}` }>
                    {this.props.patientId ?
                        <div>
                            <span
                                style={{ fontWeight: '300' }}>{$t('global.patients.patientId')}:</span> {this.props.patientId}
                        </div>
                        :
                        null
                    }
                    {this.props.patientName ?
                        <div>
                            <span
                                style={{ fontWeight: '300' }}>{$t('global.patients.patientName')}:</span> {this.props.patientName}
                        </div>
                        :
                        null
                    }
                </div>

                <div className={`${styles['third-row']}` }>
                    {$t('global.patients.deletionIsPermanent')}
                </div>
                <div className={`${styles['delete-approve']}` } onClick={() => this.deletePatient()}>
                    <div className={`${styles['delete-button']}` }>{$t('global.general.delete')}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className={`${styles['container']}` } style={this.props.style ? this.props.style : null}>
                <IoTrashOutline className={`${styles['icon']}` } onClick={() => this.presentApprovalModal()}/>

                <Modal content={this.renderContent()}
                       onClose={this.closeModals.bind(this)}
                       visible={this.state.showModal}/>
            </div>
        );
    }
}

export default ClinicDeletePatient;
